var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 62,
    fill: "#1D4EAF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 77,
    fill: "#1D4EAF",
    fillOpacity: 0.56
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 94,
    fill: "#1D4EAF",
    fillOpacity: 0.09
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.7821 117.806H79.3449C76.6256 118.509 74.611 120.984 74.611 123.92C74.611 127.401 77.4432 130.233 80.9243 130.233C84.4054 130.233 87.2376 127.401 87.2376 123.92C87.2376 120.984 85.223 118.509 82.5036 117.806H108.616C105.897 118.509 103.883 120.984 103.883 123.92C103.883 127.401 106.715 130.233 110.196 130.233C113.677 130.233 116.509 127.401 116.509 123.92C116.509 120.984 114.495 118.509 111.775 117.806H114.338C115.537 117.806 116.509 116.834 116.509 115.635C116.509 114.436 115.537 113.464 114.338 113.464H76.7821C75.6954 113.464 74.811 112.58 74.811 111.493C74.811 110.408 75.6924 109.525 76.7768 109.523H76.7799C76.7838 109.523 76.7872 109.522 76.7895 109.522L76.7915 109.522H114.338C114.81 109.522 115.269 109.368 115.645 109.084C116.022 108.8 116.296 108.401 116.425 107.947L124.71 78.952C124.802 78.6289 124.818 78.2889 124.757 77.9585C124.695 77.6282 124.558 77.3167 124.356 77.0484L124.276 77.1086L124.356 77.0483C124.154 76.78 123.892 76.5623 123.591 76.4124C123.29 76.2625 122.958 76.1845 122.622 76.1844H72.0804L70.6174 69.6001L70.6174 69.6001C70.5101 69.1179 70.2417 68.6866 69.8563 68.3775C69.4709 68.0685 68.9917 67.9 68.4977 67.9H56.0711C54.8719 67.9 53.9 68.8719 53.9 70.0711C53.9 71.2703 54.8719 72.2422 56.0711 72.2422H66.7563C67.2102 74.2857 73.6624 103.322 74.1986 105.734C72.0028 106.723 70.4688 108.932 70.4688 111.493C70.4688 114.974 73.301 117.806 76.7821 117.806ZM78.5236 105.18L73.0451 80.5266H119.744L112.7 105.18H78.5236ZM80.9243 121.949C82.0109 121.949 82.8954 122.833 82.8954 123.92C82.8954 125.006 82.0109 125.891 80.9243 125.891C79.8376 125.891 78.9532 125.006 78.9532 123.92C78.9532 122.833 79.8376 121.949 80.9243 121.949ZM110.196 121.949C111.282 121.949 112.167 122.833 112.167 123.92C112.167 125.006 111.282 125.891 110.196 125.891C109.109 125.891 108.225 125.006 108.225 123.92C108.225 122.833 109.109 121.949 110.196 121.949Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty_cart.23aefa99306c76a0ff117f9614be605c.svg";
export { ForwardRef as ReactComponent };